import React from 'react';
import { View, StyleSheet } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { OPComponent, I18n, Utils, NavBar, CTAButton } from '../components';

import { registerUser, login, resetState } from './actions';
import { COLOR, FONT, FONT_SIZE, THEME_DARK, __WEB__ } from '../../constants/styles';
import CommonStyles from './common_styles';
import StyledInput from './styled_input';
import { ErrorView, AuthForm } from './auth_views';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

const fullNameInputRef = React.createRef();
const passwordInputRef = React.createRef();

class Register extends OPComponent {
  static navigatorStyle = NavBar.authNavbarStyle;
  static statusBarStyle = NavBar.authStatusBarStyle;

  constructor(props) {
    super(props);

    this.state = {
      passwordHidden: true,
      email: props.email || null,
      password: null,
      fullName: props.username || null,
      errorMessage: null,
      lockEmail: !!props.email,
    };
  }

  componentDidMount() {
    Utils.trackScreen('Auth', 'Register');
  }

  componentWillUnmount() {
    this.props.actions.resetState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.email && !prevProps.email) {
      this.setState({
        email: this.props.email,
        fullName: this.props.username,
        lockEmail: true,
      });
    }
  }

  handleCodeChange = (mfaToken) => this.setState({ mfaToken });
  handleEmailChange = (email) => this.setState({ email });
  handlePasswordChange = (password) => this.setState({ password });
  handleEmailSubmit = () => fullNameInputRef.current?.focus?.();
  handleSecureTextButtonPress = () => this.setState({ passwordHidden: !this.state.passwordHidden });
  handleFullnameChange = (fullName) => this.setState({ fullName });
  handleFullnameSubmit = () => passwordInputRef.current?.focus?.();

  errorMessage() {
    // return "Invalid email or password";
    const submitError =
      this.props.authStatus === FAILED
        ? this.props.errorMessage?.message?.toString() || I18n.t('genericErrorMessage')
        : null;
    return (
      this.state.validationErrorMessage || this.props.inviteErrorMessage?.message || submitError
    );
  }

  submit = () => {
    if (!Utils.validate.email(this.state.email)) {
      this.setState({ validationErrorMessage: I18n.t('invalidEmail') });
      return;
    }
    if (!this.state.fullName?.trim()) {
      this.setState({ validationErrorMessage: I18n.t('auth.enterFullName') });
      return;
    }
    if (!this.state.password?.trim() || this.state.password.trim().length < 8) {
      this.setState({ validationErrorMessage: I18n.t('auth.passwordMinLength') });
      return;
    }
    if (this.state.validationErrorMessage) this.setState({ validationErrorMessage: null });

    Utils.trackEvent('Action', 'Tap', 'Signup');

    this.props.actions.registerUser({
      email: this.state.email.trim(),
      fullname: this.state.fullName.trim(),
      password: this.state.password.trim(),
    });
  };

  login = () => {
    this.props.actions.login(
      this.state.email?.trim(),
      this.state.password?.trim(),
      this.state.mfaToken?.trim()
    );
  };

  renderRegister() {
    const props = this.props;
    if (props.needsMFASetup) return null;
    if (props.needsMFACode) return null;

    return (
      <View style={styles.inputsContainer}>
        <ErrorView {...props} errorMessage={this.errorMessage()} />

        <StyledInput
          label={I18n.ac('form.emailAddress')}
          value={this.state.email}
          editable={!this.state.lockEmail}
          onChangeText={this.handleEmailChange}
          onSubmitEditing={this.handleEmailSubmit}
          autoComplete={'email'}
          keyboardType="email-address"
          returnKeyType="next"
          testID="email"
        />

        <StyledInput
          ref={fullNameInputRef}
          label={I18n.ac('auth.fullName')}
          value={this.state.fullName}
          editable={!this.state.lockEmail}
          onChangeText={this.handleFullnameChange}
          onSubmitEditing={this.handleFullnameSubmit}
          autoComplete={'name'}
          autoCapitalize="words"
          returnKeyType="next"
          testID="fullName"
        />

        <StyledInput
          ref={passwordInputRef}
          label={I18n.ac('auth.password')}
          value={this.state.password}
          secureTextEntry={!!this.state.passwordHidden}
          onChangeText={this.handlePasswordChange}
          onSubmitEditing={this.submit}
          onSecureTextButtonPress={this.handleSecureTextButtonPress}
          autoComplete={'password'}
          returnKeyType="go"
          testID="password"
        />

        <CTAButton onPress={this.submit} label={I18n.t('auth.signUp')} />
      </View>
    );
  }

  render() {
    const props = this.props;
    return (
      <AuthForm
        {...props}
        errorMessage={this.errorMessage()}
        mfaToken={this.state.mfaToken}
        onSubmitMFA={this.login}
        handleCodeChange={this.handleCodeChange}
        showActivityOverlay={props.authStatus === REQUESTING}
        showPrivacy={true}
      >
        {this.renderRegister()}
      </AuthForm>
    );
  }
}

const styles = StyleSheet.create({
  ...CommonStyles,
});

function mapStateToProps(state, ownProps) {
  return {
    authStatus: state.screens.auth.status,
    errorMessage: state.screens.auth.errorMessage,
    successMessage: state.screens.auth.successMessage,
    inviteErrorMessage: state.screens.invites.errorMessage,
    email: state.application.authFormPrefills?.email,
    username: state.application.authFormPrefills?.username,
    needsMFASetup: state.screens.auth.needsMFASetup,
    needsMFACode: state.screens.auth.needsMFACode,
    qrcode: state.screens.auth.qrcode,
    secret: state.screens.auth.secret,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ registerUser, login, resetState }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Register);
